// ============================================================================
// Cursor - Custom cursor management for game canvas
// ============================================================================

// SVG sword cursor as data URL
const SWORD_CURSOR = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'%3E%3Cdefs%3E%3Cfilter id='shadow' x='-20%25' y='-20%25' width='140%25' height='140%25'%3E%3CfeDropShadow dx='1' dy='1' stdDeviation='1' flood-color='%23000' flood-opacity='0.5'/%3E%3C/filter%3E%3C/defs%3E%3Cg filter='url(%23shadow)'%3E%3C!-- Blade --%3E%3Cpath d='M6 26 L14 18 L16 14 L18 16 L10 24 Z' fill='%23e8e8e8' stroke='%23666' stroke-width='0.5'/%3E%3C!-- Blade edge highlight --%3E%3Cpath d='M7 25 L14 18 L15 15' fill='none' stroke='%23fff' stroke-width='0.5'/%3E%3C!-- Guard --%3E%3Crect x='16' y='14' width='6' height='2' rx='0.5' fill='%23c9a227' stroke='%23a08020' stroke-width='0.5' transform='rotate(45 19 15)'/%3E%3C!-- Handle --%3E%3Cpath d='M20 12 L25 7' stroke='%238b4513' stroke-width='3' stroke-linecap='round'/%3E%3Cpath d='M20 12 L25 7' stroke='%23a0522d' stroke-width='2' stroke-linecap='round'/%3E%3C!-- Pommel --%3E%3Ccircle cx='26' cy='6' r='2' fill='%23c9a227' stroke='%23a08020' stroke-width='0.5'/%3E%3C/g%3E%3C/svg%3E") 4 28, crosshair`;

// Cursor types
export const CursorType = {
  DEFAULT: 'default',
  POINTER: 'pointer',
  CROSSHAIR: 'crosshair',
  ATTACK: SWORD_CURSOR,
  MOVE: 'move',
  GRAB: 'grab',
  GRABBING: 'grabbing',
  NOT_ALLOWED: 'not-allowed',
} as const;

export type CursorTypeValue = (typeof CursorType)[keyof typeof CursorType];

// Current cursor state
let currentCursor: CursorTypeValue = CursorType.DEFAULT;
let canvasElement: HTMLCanvasElement | null = null;

// Initialize cursor manager
export const initCursor = ({ canvas }: { canvas: HTMLCanvasElement }): void => {
  canvasElement = canvas;
};

// Set cursor type
export const setCursor = ({ cursor }: { cursor: CursorTypeValue }): void => {
  if (currentCursor === cursor) {
    return;
  }
  currentCursor = cursor;
  if (canvasElement) {
    canvasElement.style.cursor = cursor;
  }
};

// Reset to default cursor
export const resetCursor = (): void => {
  setCursor({ cursor: CursorType.DEFAULT });
};

// Get current cursor
export const getCurrentCursor = (): CursorTypeValue => {
  return currentCursor;
};
